import React from 'react';
import { Typography, Box } from '@mui/material';
import { IQueryUsage } from '../../../Types/Docs';

interface QueryUsageFooterProps {
  usage: IQueryUsage;
  'data-testid'?: string;
}

const QueryUsageFooter: React.FC<QueryUsageFooterProps> = ({
  usage,
  'data-testid': testId,
}) => {
  const latencySec = (usage.latencyMs / 1000).toFixed(1);

  return (
    <Box sx={{ mt: 2, textAlign: 'right' }} data-testid={testId}>
      <Typography variant="caption" color="text.secondary">
        {latencySec}s · {usage.inputTokens.toLocaleString()} input /{' '}
        {usage.outputTokens.toLocaleString()} output tokens
      </Typography>
    </Box>
  );
};

export default QueryUsageFooter;
